import React from "react";
import Header from "../../../../Components/Header";
import Deliverynote from "./Deliverynote";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";

const Create = () => {
  const location = useLocation();
  const { picklist_id, is_new } = location.state || {};

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Delivery Note - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Deliverynote picklist_id={picklist_id} is_new={is_new} />

      </div>
    </div>

  );
};

export default Create;
